import { startOfWeek } from "date-fns";
import { useEffect, useState } from "react";
import { IPropertyGroup } from "../../models/propertyGroup";
import propertyGroupService from "../../services/propertyGroupService/PropertyGroupService";

const useWorkRoute = () => {
    const [start, setStart] = useState<Date>(startOfWeek(new Date()));
    const [end, setEnd] = useState<Date | undefined>(new Date());
    const [propertyGroups, setPropertyGroups] = useState<IPropertyGroup[]>([]);
    const [propertyGroupId, setPropertyGroupId] = useState<number>(-1);


    useEffect(() => {
        const loadInitialData = async () => {
            const groups = await propertyGroupService.GetPropertyGroups();
            setPropertyGroups(groups);

            if (groups.length > 0 && propertyGroupId === -1) {
                setPropertyGroupId(groups[0].id);
            }
        };

        loadInitialData();
    }, []);

    return {
        propertyGroupId,
        setPropertyGroupId,
        start,
        end,
        propertyGroups,
        setStart,
        setEnd,
    };
};

export default useWorkRoute;
